import { render, staticRenderFns } from "./ListPI.vue?vue&type=template&id=2641ef72&"
import script from "./ListPI.vue?vue&type=script&lang=js&"
export * from "./ListPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports